export const CLAIM_INFO_CODE = 'MEMBER_CLAIM_INFO';
